import Vue from 'vue'
import VueRouter from 'vue-router';

import Home from '../views/Home.vue';
import Terms from '../views/Terms.vue';
import Faqs from '../views/Faqs.vue';
import Privacy from '../views/Privacy.vue';
import Cookies from '../views/Cookies.vue';
import Responsibility from '../views/Responsibility.vue';
import Blog from '../views/Blog.vue';
import Press from '../views/Press.vue';
import Jobs from '../views/Jobs.vue';
import Investors from '../views/Investors.vue';
import City from '../views/City.vue';
import Country from '../views/Country.vue';
import Continent from '../views/Continent.vue';
import Hotels from '../views/Hotels.vue';
import HotelDetails from '../views/HotelDetails.vue';
import HotelBook from '../views/HotelBook.vue';
import Error404 from '../views/404.vue';

Vue.use(VueRouter, {
  defaultLanguage: 'en-us',
});

const routes = [
  {
    path: '/',
    redirect: '/en-us',
  },
  {
    path: '/hotels',
    redirect: '/en-us/hotels',
  },
  {
    path: '/page/:slug',
    redirect: '/en-us/page/:slug',
  },
  {
    path: '/destination/:continent/:country/:city',
    redirect: '/en-us/destination/:continent/:country/:city',
  },
  {
    path: '/destination/:continent/:country',
    redirect: '/en-us/destination/:continent/:country',
  },
  {
    path: '/destination/:continent',
    redirect: '/en-us/destination/:continent',
  },
  {
    path: '/hotel/:hotel/:id',
    redirect: '/en-us/hotel/:hotel/:id',
  },
  {
    path: '/book/:hotel/:id/:offer',
    redirect: '/en-us/book/:hotel/:id/:offer',
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/hotels/',
    name: 'Hotels',
    component: Hotels,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/hotel/:hotel/:id',
    name: 'Hotel Details',
    component: HotelDetails,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/book/:hotel/:id/:offer',
    name: 'Book Hotel',
    component: HotelBook,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)',
    name: 'Home',
    component: Home,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/terms-and-conditions',
    name: 'Terms & Condition',
    component: Terms,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/faqs',
    name: 'Freqently Asked Questions',
    component: Faqs,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/privacy',
    name: 'Privacy Policy',
    component: Privacy,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/cookies',
    name: 'Cookie Policy',
    component: Cookies,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/corporate-responsibility',
    name: 'Corporate Responsibility',
    component: Responsibility,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/press',
    name: 'Press',
    component: Press,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/jobs',
    name: 'Jobs',
    component: Jobs,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/investors',
    name: 'Investors',
    component: Investors,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/page/blog',
    name: 'Blog',
    component: Blog,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/destination/:continent/:country/:city',
    name: 'City',
    component: City,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/destination/:continent/:country',
    name: 'Country',
    component: Country,
  },
  {
    path: '/:locale(en-us|en-gb|nl-nl|nl-be)/destination/:continent',
    name: 'Continent',
    component: Continent,
  },
  {
    path: '/*',
    name: '404',
    component: Error404,
    //component: () => import(/* webpackChunkName: "about" */ '../views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },  
  routes
})

export default router
